// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700,800);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Public+Sans:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-img-class {
  width: 682px !important;
  height: 862px !important;
}
.login-head {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 300 !important;
  line-height: 39.01px !important;
  letter-spacing: 0px !important;
  color: #1d1d1d !important;
}
.sub-head {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 600 !important ;
  line-height: 39.01px !important;
  letter-spacing: 0px !important;
}
.sub-title {
  font-family: "Montserrat" !important;
  font-size: 22px !important;
  font-weight: 500.25 !important;
  line-height: 26.82px !important;
  letter-spacing: 0px !important;
  text-align: left;
  color: #3D4A52 !important;
  padding-top: 10px !important;
}
.sub-title-head {
  font-family: "Montserrat" !important;
  font-size: 22px !important;
  font-weight: 400 !important;
  line-height: 26.82px !important;
  letter-spacing: 0px !important;
  text-align: left;
  color: #3D4A52 !important;
  padding-top: 10px !important;
}
.login-heading {
  margin: 30px 40px !important;
}
.login-input-field {
  width: 526px !important;
  margin: 2px 55px 30px 46px !important;
}
.submit-btn {
  width: 85%;
  margin: 0 10% !important;
  height: 55px;
  border-radius: 12px !important;
  background-color: #108e24 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  box-shadow: none !important;
}
.disable-btn {
  width: 85%;
  margin: 0 10% !important;
  height: 55px;
  border-radius: 12px !important;
  background-color: #108e24 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  opacity: 0.5 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.homepage-logo {
  height: 105px;
  width: 282px;
  margin-top: 30px;
  margin-left: 30px;
}
.mb60 {
  margin-bottom: 60px !important;
}
.input-text-label {
  margin: 30px 55px !important;
  font-weight: 500;
  font-size: 16px;
}

.css-1wc848c-MuiFormHelperText-root {
  font-size: 12px !important;
  color: rgb(255 255 255);
  font-weight: 600 !important;
  font-size: 14px !important;
}
.Send-Otp {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  width: 172px !important;
  height: 48px !important;
  padding: 11px, 55px, 11px, 56px !important;
  border-radius: 8px !important;
  background-color: #00ab55 !important;
  color: #ffffff !important;
  text-transform: capitalize !important;
  cursor: pointer !important;
  box-shadow: none !important;
}
.Send-Otp:disabled {
  background-color: #79a280 !important;
  color: white !important;
  box-shadow: none !important;
}
.timer {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  padding-left: 5px !important;
}
.resendLeft{
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 300 !important;
  line-height: 19.5px !important;
}
.resendButton {
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #094bca !important;
  text-transform: capitalize !important;
}
.resendButton:disabled{
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #7d98b3 !important;
  text-transform: capitalize !important;
}
.primaryButton{
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  width: 172px !important;
  height: 48px !important;
  padding: 11px, 55px, 11px, 56px !important;
  border-radius: 8px !important;
  border: 1px solid #00ab55 !important ;
  box-shadow: none !important;
  color: #00ab55 !important;
  background-color: none !important;
  text-transform: capitalize !important;
  cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.css"],"names":[],"mappings":"AAIA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;AAC5B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700,800\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Public+Sans:wght@300;400;600;700&display=swap\");\n\n.home-img-class {\n  width: 682px !important;\n  height: 862px !important;\n}\n.login-head {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 300 !important;\n  line-height: 39.01px !important;\n  letter-spacing: 0px !important;\n  color: #1d1d1d !important;\n}\n.sub-head {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 600 !important ;\n  line-height: 39.01px !important;\n  letter-spacing: 0px !important;\n}\n.sub-title {\n  font-family: \"Montserrat\" !important;\n  font-size: 22px !important;\n  font-weight: 500.25 !important;\n  line-height: 26.82px !important;\n  letter-spacing: 0px !important;\n  text-align: left;\n  color: #3D4A52 !important;\n  padding-top: 10px !important;\n}\n.sub-title-head {\n  font-family: \"Montserrat\" !important;\n  font-size: 22px !important;\n  font-weight: 400 !important;\n  line-height: 26.82px !important;\n  letter-spacing: 0px !important;\n  text-align: left;\n  color: #3D4A52 !important;\n  padding-top: 10px !important;\n}\n.login-heading {\n  margin: 30px 40px !important;\n}\n.login-input-field {\n  width: 526px !important;\n  margin: 2px 55px 30px 46px !important;\n}\n.submit-btn {\n  width: 85%;\n  margin: 0 10% !important;\n  height: 55px;\n  border-radius: 12px !important;\n  background-color: #108e24 !important;\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  box-shadow: none !important;\n}\n.disable-btn {\n  width: 85%;\n  margin: 0 10% !important;\n  height: 55px;\n  border-radius: 12px !important;\n  background-color: #108e24 !important;\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  opacity: 0.5 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.homepage-logo {\n  height: 105px;\n  width: 282px;\n  margin-top: 30px;\n  margin-left: 30px;\n}\n.mb60 {\n  margin-bottom: 60px !important;\n}\n.input-text-label {\n  margin: 30px 55px !important;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.css-1wc848c-MuiFormHelperText-root {\n  font-size: 12px !important;\n  color: rgb(255 255 255);\n  font-weight: 600 !important;\n  font-size: 14px !important;\n}\n.Send-Otp {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  width: 172px !important;\n  height: 48px !important;\n  padding: 11px, 55px, 11px, 56px !important;\n  border-radius: 8px !important;\n  background-color: #00ab55 !important;\n  color: #ffffff !important;\n  text-transform: capitalize !important;\n  cursor: pointer !important;\n  box-shadow: none !important;\n}\n.Send-Otp:disabled {\n  background-color: #79a280 !important;\n  color: white !important;\n  box-shadow: none !important;\n}\n.timer {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  padding-left: 5px !important;\n}\n.resendLeft{\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 300 !important;\n  line-height: 19.5px !important;\n}\n.resendButton {\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 24px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #094bca !important;\n  text-transform: capitalize !important;\n}\n.resendButton:disabled{\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 24px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #7d98b3 !important;\n  text-transform: capitalize !important;\n}\n.primaryButton{\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  width: 172px !important;\n  height: 48px !important;\n  padding: 11px, 55px, 11px, 56px !important;\n  border-radius: 8px !important;\n  border: 1px solid #00ab55 !important ;\n  box-shadow: none !important;\n  color: #00ab55 !important;\n  background-color: none !important;\n  text-transform: capitalize !important;\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
